import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSkillsByResumeCount } from "../../slice/workerResumeSlice";

const WorkerSkillsByResumeCount = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");

    const { skillsByResume, loading, error } = useSelector(
        (state) => state.workerResume
    );

    useEffect(() => {
        if (!token) return;
        dispatch(getSkillsByResumeCount(token));
    }, [token, dispatch]);

    // if (loading) return <p>Loading...</p>;
    // if (error) return <p className="text-danger">{error}</p>;

    return (
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
            <div className="ps-2 ps-lg-4">
                <h4 className="fw-bold text-primary mb-4 border-bottom pb-3">
                    Resume By Skills
                </h4>

                {/* 🔄 Loading */}
                {loading && (
                    <div className="d-flex justify-content-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}

                {/* ❌ Error */}
                {!loading && error && (
                    <div className="alert alert-danger text-center">
                        {typeof error === "string" ? error : error.message}
                    </div>
                )}


                {!loading && !error && (
                    <div className="row g-3">
                        {skillsByResume?.length ? (
                            skillsByResume.map((skill, index) => (
                                <div key={index} className="col-md-4">
                                    <div className="card shadow-sm">
                                        <div className="card-body d-flex justify-content-between align-items-center">

                                            {/* Skill Name */}
                                            <h6 className="mb-0 text-capitalize fw-semibold">
                                                {skill.skill}
                                            </h6>

                                            {/* Count */}
                                            <span className="text-muted">
                                                {skill.total}
                                            </span>

                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No skills found.</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WorkerSkillsByResumeCount;
